module.exports = __webpack_public_path__ + "img/logo_fxswap.25f7af49.png";